import React, { SVGProps } from 'react';

type Props = {} & SVGProps<SVGSVGElement>;
export default function OverviewChartIcon(props: Props) {
    return (
        <svg
            {...props}
            width={props.width ?? 32}
            height={props.height ?? 39}
            viewBox={props.viewBox ?? '0 0 32 39'}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="32" height="32" rx="16" fill="#E8F5E9" />
            <path
                d="M20.5 12.9L16 10.2L11.5 12.9"
                stroke="#2E7D32"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M11.5 13V19.1L16 16.4L20.5 19.1V13"
                stroke="#2E7D32"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M18.2 20.2L16 21.7L13.8 20.2"
                stroke="#2E7D32"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z"
                stroke="#2E7D32"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
}
